import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from 'components/DesignSystem/Button';
import Icon from 'components/DesignSystem/Icon';
import { ModelType } from 'components/Meteorology/Fields/ControlPanel/Comparator/modelAccordion';
import useComparatorControlPanel from 'utils/hooks/meteorology/comparator/useComparatorControlPanel';
import useComparatorParams from 'utils/hooks/meteorology/comparator/useComparatorParams';
import useComparatorSavePreferencesModal from 'utils/hooks/meteorology/useComparatorSavePreferencesModal';
import useControlPanelOptions from 'utils/hooks/meteorology/useControlPanelOptions';
import { setTriggerActivity } from 'redux/reducers/meteorologyFieldsComparatorControlPanelReducer';
import { cssVar } from 'constants/theme';
import ModelStep from '../ModelStep';

import './index.scss';

type NovaStep = 'form' | ModelType;

export default function NovaForm({ onGenerate }: { onGenerate: () => void }) {
  const [step, setStep] = useState<NovaStep>('form');
  const dispatch = useDispatch();
  const { models } = useControlPanelOptions('comparador');
  const { baseModel, confrontationalModel, resetPreferences } = useComparatorControlPanel();
  const { setShowFormModal } = useComparatorSavePreferencesModal();
  const comparatorParams = useComparatorParams();

  const modelLabel = (value: string | undefined) => (
    models.find((m) => m.value === value)?.label ?? 'Selecionar'
  );

  const generate = () => {
    dispatch(setTriggerActivity(true));
    onGenerate();
  };

  if (step === ModelType.CONFRONTATIONAL) {
    return (
      <ModelStep
        modelType={ModelType.CONFRONTATIONAL}
        title="Modelo Confrontante (A)"
        onBack={() => setStep('form')}
      />
    );
  }

  if (step === ModelType.BASE) {
    return (
      <ModelStep
        modelType={ModelType.BASE}
        title="Modelo Base (B)"
        onBack={() => setStep('form')}
      />
    );
  }

  return (
    <div className="nova-form">
      <button
        type="button"
        className="nova-form-row"
        onClick={() => setStep(ModelType.CONFRONTATIONAL)}
      >
        <div>
          <span className="nova-form-row-label">Modelo Confrontante (A)</span>
          <span className="nova-form-row-value text-uppercase">
            {modelLabel(confrontationalModel)}
          </span>
        </div>
        <Icon iconType="right_arrow" color={cssVar('text-strong')} />
      </button>
      <button
        type="button"
        className="nova-form-row"
        onClick={() => setStep(ModelType.BASE)}
      >
        <div>
          <span className="nova-form-row-label">Modelo Base (B)</span>
          <span className="nova-form-row-value text-uppercase">{modelLabel(baseModel)}</span>
        </div>
        <Icon iconType="right_arrow" color={cssVar('text-strong')} />
      </button>

      <div className="nova-form-actions">
        <Button disabled={comparatorParams === undefined} onClick={generate}>
          Gerar comparação
        </Button>
        <Button type="secondary" onClick={() => setShowFormModal(true)}>
          Salvar nova preferência
        </Button>
        <Button type="tertiary" onClick={resetPreferences}>
          Limpar filtros
        </Button>
      </div>
    </div>
  );
}
